import { USERS } from "../Constants/Endpoinst";
// import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchUsers = async () => {
  const method = "GET";

  const loginData = localStorage.getItem("logindata");
  const token = loginData ? JSON.parse(loginData)?.data?.token : null;

  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const response = await ApiRequestInterceptor(USERS.users, method, null, headers);

  if (response.code === 200) {
    return response.data.items;
  } else {
    throw new Error("Error al obtener los usuarios");
  }
};
